const actions = {
  LIST_PAGOS_REGISTRADOS: 'LIST_PAGOS_REGISTRADOS',
  LIST_PAGOS_REGISTRADOS_SELECTBOX: 'LIST_PAGOS_REGISTRADOS_SELECTBOX',
  READ_PAGOS_REGISTRADOS: 'READ_PAGOS_REGISTRADOS',

  pagosRegistradosList: data => {     
    return {
      type: actions.LIST_PAGOS_REGISTRADOS,
      data,
    };
  },

  pagosRegistradosListSelectBox: data => {
    return {
      type: actions.LIST_PAGOS_REGISTRADOS_SELECTBOX,
      data,
    };
  },

  pagosRegistradosRead: data => {
    return {
      type: actions.READ_PAGOS_REGISTRADOS,
      data,
    };
  },

};

export default actions;
